module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_7042.b602c7db.png";